import { Snackbar } from '@finpay-development/shared-components';
import { hideStatus } from '@finpay-development/shared-platform/lib/esm/security/state/user-slice';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../state/root-reducer';
import { AppDispatch } from '../state/store';

export function ApplicationStatusSnackbar() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const applicationStatus = useSelector(
    (state: RootState) => state.userContext.applicationStatus
  );

  return (
    <Snackbar
      open={applicationStatus.showMessage}
      message={applicationStatus.message}
      type={applicationStatus.messageType}
      onClose={() => dispatch(hideStatus())}
      onNavigate={(path) => {
        navigate(path);
        dispatch(hideStatus());
      }}
    />
  );
}
